import type { AddLineItemType } from "@/Shared/Types/lineItemTypes";
import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";
import type { Hours } from "@freightsimple/generated-dashboard-openapi-client/models/Hours";
import type { LineItem } from "@freightsimple/generated-dashboard-openapi-client/models/LineItem";
import type { Location } from "@freightsimple/generated-dashboard-openapi-client/models/Location";
import type { Quote } from "@freightsimple/generated-dashboard-openapi-client/models/Quote";
import type { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

import ShipmentRowBody from "@/Shared/Shipment/CustomComponents/ShipmentRowBody";

interface DashboardRowProps {
  shipmentState: ShipmentState;
  lineItems: Array<AddLineItemType | LineItem>;
  pickupLocation: AddLocationLocationType | Location;
  deliveryLocation: AddLocationLocationType | Location;
  pickupDate: string | undefined;
  pickupHours: Hours | undefined;
  appointmentDate: string | undefined;
  expectedDeliveryDate: string | undefined;
  expectedDeliveryHours: string | undefined;
  actualDeliveryDate: string | undefined;
  actualDeliveryTime: string | undefined;
  carrierIdentifier: string | undefined;
  onClick: () => void;
  selectedQuote?: Quote | undefined;
  cheapestQuote?: Quote | undefined;
  pickupReference: string;
  deliveryReference: string;
  onDelete?: (() => Promise<void>) | undefined;
  overrideLastColumnLabel?: string | undefined;
  overrideLastColumnDescription?: string | undefined;
  needsCustomsDocs?: boolean | undefined;
  manualQuotingOpen: boolean;
  freightClaims?: boolean | undefined;
  bookedByName?: string | undefined;
}

function ShipmentRow(props: DashboardRowProps) {
  return <ShipmentRowBody {...props} />;
}
export default ShipmentRow;
